import React from "react";
import { GlassCard } from "../components/GlassCard";
import { Tag } from "../components/Tag";

export const HomePage = ({ c, isDark, setPage }) => {
  const bgDot = isDark
    ? "radial-gradient(rgba(255,255,255,0.04) 1px, transparent 1px)"
    : "radial-gradient(rgba(0,0,50,0.06) 1px, transparent 1px)";

  return (
    <div style={{ background: c.background, minHeight: "100vh", backgroundImage: bgDot, backgroundSize: "32px 32px" }}>
      <section style={{
        minHeight: "100vh", paddingTop: 160, paddingBottom: 120,
        display: "flex", flexDirection: "column", alignItems: "center",
        justifyContent: "center", position: "relative", padding: "160px 24px 120px",
      }}>
        <div style={{
          position: "absolute", width: 800, height: 800,
          background: `${c.primary}18`, borderRadius: "50%",
          filter: "blur(120px)", top: "50%", left: "50%",
          transform: "translate(-50%,-50%)", pointerEvents: "none",
        }} />

        <div className="fade-in" style={{ position: "relative", zIndex: 1, maxWidth: 960, textAlign: "center" }}>
          <GlassCard isDark={isDark} style={{
            borderRadius: 24, padding: "64px 48px",
            boxShadow: `0 0 40px 0 ${isDark ? "rgba(173,198,255,0.08)" : "rgba(0,90,194,0.1)"}`,
          }}>
            <div style={{ display: "flex", justifyContent: "center", marginBottom: 24 }}>
              <span style={{
                fontFamily: "'JetBrains Mono', monospace", fontSize: 12,
                background: isDark ? c.surfaceContainer : c.surfaceContainerLow,
                padding: "6px 20px", borderRadius: 9999, color: c.secondary,
                border: `1px solid ${isDark ? "rgba(66,71,84,0.3)" : "rgba(0,0,0,0.06)"}`,
                letterSpacing: "0.1em",
              }}>AVAILABLE FOR SCALE</span>
            </div>

            <h1 style={{
              fontFamily: "'Geist', sans-serif", fontWeight: 700, lineHeight: 1.1,
              letterSpacing: "-0.02em", fontSize: "clamp(36px, 6vw, 64px)",
              color: c.onSurface, marginBottom: 32,
            }}>
              Full-Stack Engineer crafting scalable and{" "}
              <span style={{
                background: `linear-gradient(135deg, ${c.primary}, ${c.secondary})`,
                WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
              }}>
                modern digital experiences.
              </span>
            </h1>

            <p style={{
              fontFamily: "'Geist', sans-serif", fontSize: 18, lineHeight: 1.6,
              color: c.onSurfaceVariant, maxWidth: 600, margin: "0 auto 48px",
            }}>
              Focusing on high-performance architecture, clean code, and seamless user experiences.
            </p>

            <div style={{ display: "flex", gap: 16, justifyContent: "center", flexWrap: "wrap" }}>
              <button onClick={() => setPage("Projects")} style={{
                padding: "14px 32px", borderRadius: 8, border: "none", cursor: "pointer",
                background: `linear-gradient(135deg, ${c.primaryContainer}, ${c.secondaryContainer})`,
                color: "#fff", fontFamily: "'Geist', sans-serif", fontWeight: 600, fontSize: 16,
                transition: "all 0.2s",
              }}>View Projects</button>

              <button onClick={() => setPage("Contact")} style={{
                padding: "14px 32px", borderRadius: 8, cursor: "pointer",
                background: "transparent",
                border: `1px solid ${isDark ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.12)"}`,
                color: c.onSurface, fontFamily: "'Geist', sans-serif", fontWeight: 600, fontSize: 16,
                transition: "all 0.2s",
              }}>Contact Me</button>

              <button style={{
                padding: "14px 24px", borderRadius: 8, cursor: "pointer",
                background: "transparent", border: "none",
                color: c.onSurfaceVariant, fontFamily: "'JetBrains Mono', monospace",
                fontSize: 12, display: "flex", alignItems: "center", gap: 8,
                transition: "color 0.2s",
              }}>
                <span className="material-symbols-outlined" style={{ fontSize: 18 }}>download</span>
                Download Resume
              </button>
            </div>

            <div style={{
              marginTop: 64, paddingTop: 40,
              borderTop: `1px solid ${isDark ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.05)"}`,
              display: "flex", gap: 48, justifyContent: "center", flexWrap: "wrap",
              opacity: 0.6, filter: "grayscale(1)",
              transition: "all 0.5s",
            }}
              onMouseEnter={e => { e.currentTarget.style.opacity = 1; e.currentTarget.style.filter = "none"; }}
              onMouseLeave={e => { e.currentTarget.style.opacity = 0.6; e.currentTarget.style.filter = "grayscale(1)"; }}
            >
              {[
                { icon: "terminal", label: "GoLang" },
                { icon: "layers", label: "React & Next.js" },
                { icon: "storage", label: "PostgreSQL" },
                { icon: "cloud", label: "Kubernetes" },
              ].map(({ icon, label }) => (
                <div key={label} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <span className="material-symbols-outlined" style={{ color: c.onSurface }}>{icon}</span>
                  <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 14, color: c.onSurface }}>{label}</span>
                </div>
              ))}
            </div>
          </GlassCard>
        </div>

        <div style={{
          position: "absolute", bottom: 40, left: "50%", transform: "translateX(-50%)",
          display: "flex", flexDirection: "column", alignItems: "center", gap: 8, opacity: 0.4,
        }}>
          <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 12, color: c.onSurface }}>SCROLL_DOWN</span>
          <div style={{ width: 1, height: 48, background: `linear-gradient(to bottom, ${c.primary}, transparent)` }} />
        </div>
      </section>

      <section style={{ maxWidth: 1280, margin: "0 auto", padding: "0 64px 120px" }}>
        <div style={{ display: "grid", gridTemplateColumns: "8fr 4fr", gap: 32 }}>
          <GlassCard isDark={isDark} style={{ borderRadius: 16, overflow: "hidden", cursor: "pointer", transition: "all 0.3s" }} className="glass-before">
            <div style={{ aspectRatio: "16/9", overflow: "hidden", background: c.surfaceContainer }}>
              <img
                src="https://lh3.googleusercontent.com/aida-public/AB6AXuC3s0IF9heqvsrmNxW_-xYa87Iz7-juqIrrafJvKc-gdGb08Lp1xx1zRgV-nstm4gS98btTmz-LOVwVmV3Yd1zNqDX1_W99aPNZvnxCu4dTbKqfBABoLqJexLOOI7Z7ZlWPfYmJMAQEhGxmG6NQIGIqxCVqqhzhbqgLuUvfIdhmlquoDEJwD6K0oCK9t-Gq3hJgMjfhyZvGNDbUsqmFIia3jai17Tp7XeDjyFOvCBUuEbNygNhfpPLbuIbCL8CBx0Ogg9QmT7xhCnk"
                alt="Architecture Dashboard"
                style={{ width: "100%", height: "100%", objectFit: "cover", transition: "transform 0.7s" }}
                onMouseEnter={e => e.target.style.transform = "scale(1.05)"}
                onMouseLeave={e => e.target.style.transform = "scale(1)"}
              />
            </div>
            <div style={{ padding: 32, display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
              <div>
                <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 12, color: c.secondary, display: "block", marginBottom: 8 }}>PROJECT_01</span>
                <h3 style={{ fontFamily: "'Geist', sans-serif", fontSize: 28, fontWeight: 600, color: c.onSurface, marginBottom: 12 }}>Neural Infrastructure Monitor</h3>
                <p style={{ fontFamily: "'Geist', sans-serif", fontSize: 16, color: c.onSurfaceVariant, maxWidth: 480 }}>
                  A real-time distributed systems visualizer built with WebGL and Rust for high-throughput observability.
                </p>
              </div>
              <span className="material-symbols-outlined" style={{ color: c.primary, fontSize: 32 }}>arrow_forward</span>
            </div>
          </GlassCard>

          <div style={{ display: "flex", flexDirection: "column", gap: 32 }}>
            <GlassCard isDark={isDark} style={{ borderRadius: 16, padding: 32, flex: 1 }}>
              <div style={{ display: "flex", gap: 6, marginBottom: 24 }}>
                {["#ff5f56", "#ffbd2e", "#27c93f"].map(bg => (
                  <div key={bg} style={{ width: 12, height: 12, borderRadius: "50%", background: bg }} />
                ))}
              </div>
              <h3 style={{ fontFamily: "'Geist', sans-serif", fontSize: 24, fontWeight: 600, color: c.onSurface, marginBottom: 8 }}>Systems Architect</h3>
              <p style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 12, color: c.onSurfaceVariant, fontStyle: "italic", marginBottom: 32, lineHeight: 1.6 }}>
                "Code is not just for machines to run, but for humans to maintain."
              </p>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                {["CI/CD", "Microservices", "GraphQL"].map(t => <Tag key={t} c={c} isDark={isDark}>{t}</Tag>)}
              </div>
            </GlassCard>

            <GlassCard isDark={isDark} style={{
              borderRadius: 16, padding: 32,
              background: isDark ? `${c.primaryContainer}18` : `${c.primaryContainer}22`,
              border: `1px solid ${c.primary}30`,
            }}>
              <div style={{ fontSize: 48, fontFamily: "'Geist', sans-serif", fontWeight: 700, color: c.primary, marginBottom: 8 }}>12+</div>
              <div style={{ fontFamily: "'Geist', sans-serif", fontSize: 22, fontWeight: 600, color: c.onSurface, marginBottom: 12 }}>Years of Engineering</div>
              <p style={{ fontFamily: "'Geist', sans-serif", fontSize: 16, color: c.onSurfaceVariant }}>
                Delivering production-grade solutions for global enterprise clients.
              </p>
            </GlassCard>
          </div>
        </div>
      </section>
    </div>
  );
};